module.exports = __webpack_public_path__ + "static/img/ic_ios.5168901.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/function/ic_ios.png
// module id = ZEbq
// module chunks = 1